import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'BLOCKED_DATE_RANGE' });



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/blocked-date-range/handlers.js